import React from 'react';
import { DocumentStatusInfo } from './components/DocumentStatusInfo';

function App() {
  return (
    <>
      <DocumentStatusInfo />
    </>
  );
}

export default App;
